/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Rtl_FormattingInputs */

const en_subtitle_export_rtl_formatting = /** @type {(inputs: Subtitle_Export_Rtl_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL Formatting`)
};

const fr_subtitle_export_rtl_formatting = /** @type {(inputs: Subtitle_Export_Rtl_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatage RTL`)
};

const de_subtitle_export_rtl_formatting = /** @type {(inputs: Subtitle_Export_Rtl_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL-Formatierung`)
};

const it_subtitle_export_rtl_formatting = /** @type {(inputs: Subtitle_Export_Rtl_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattazione RTL`)
};

const ru_subtitle_export_rtl_formatting = /** @type {(inputs: Subtitle_Export_Rtl_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL-форматирование`)
};

const es_subtitle_export_rtl_formatting = /** @type {(inputs: Subtitle_Export_Rtl_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato RTL`)
};

const zh_cn2_subtitle_export_rtl_formatting = /** @type {(inputs: Subtitle_Export_Rtl_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL格式`)
};

const ja_subtitle_export_rtl_formatting = /** @type {(inputs: Subtitle_Export_Rtl_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTLフォーマット`)
};

const hi_subtitle_export_rtl_formatting = /** @type {(inputs: Subtitle_Export_Rtl_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आरटीएल प्रारूपण`)
};

const pt_pt2_subtitle_export_rtl_formatting = /** @type {(inputs: Subtitle_Export_Rtl_FormattingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação RTL`)
};

/**
* | output |
* | --- |
* | "RTL Formatting" |
*
* @param {Subtitle_Export_Rtl_FormattingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_rtl_formatting = /** @type {((inputs?: Subtitle_Export_Rtl_FormattingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Rtl_FormattingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_rtl_formatting(inputs)
	if (locale === "de") return de_subtitle_export_rtl_formatting(inputs)
	if (locale === "it") return it_subtitle_export_rtl_formatting(inputs)
	if (locale === "ru") return ru_subtitle_export_rtl_formatting(inputs)
	if (locale === "es") return es_subtitle_export_rtl_formatting(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_rtl_formatting(inputs)
	if (locale === "ja") return ja_subtitle_export_rtl_formatting(inputs)
	if (locale === "hi") return hi_subtitle_export_rtl_formatting(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_rtl_formatting(inputs)
	return en_subtitle_export_rtl_formatting(inputs)
});